type PostHogEnvironment = {
  REACT_APP_POSTHOG_PROJECT_TOKEN?: string;
  REACT_APP_PUBLIC_POSTHOG_KEY?: string;
  REACT_APP_POSTHOG_HOST?: string;
  REACT_APP_PUBLIC_POSTHOG_HOST?: string;
  REACT_APP_DEV_ENV?: string;
  NODE_ENV?: string;
};

export const resolvePostHogSettings = (environment: PostHogEnvironment) => ({
  projectToken:
    environment.REACT_APP_POSTHOG_PROJECT_TOKEN?.trim() ||
    environment.REACT_APP_PUBLIC_POSTHOG_KEY?.trim(),
  options: {
    api_host:
      environment.REACT_APP_POSTHOG_HOST?.trim() ||
      environment.REACT_APP_PUBLIC_POSTHOG_HOST?.trim() ||
      undefined,
    defaults: '2026-01-30' as const,
    logs: {
      serviceName: 'beam-app-web',
      environment:
        environment.REACT_APP_DEV_ENV || environment.NODE_ENV || 'unknown',
    },
  },
});
